module.exports = __webpack_public_path__ + "media/images/athletes/4152-f12a75528c567455809b17c4206f462c.png";